import React, { useEffect, useState } from "react";

import WmsButton from "../../../components/WmsButton/WmsButton.jsx";
import WmsDropdown from "../../../components/WmsDropdown/WmsDropdown.jsx";
import WmsInput from "../../../components/WmsInput/WmsInput.jsx";
import WmsModel from "../../../components/WmsModel/WmsModel.jsx";
import "./carrier-markup-new-version.scss";
import _ from "lodash";
import * as GlobalService from "../../../global_services.js";
import WmsFormGrid from "../../../components/WmsFormGrid/WmsFormGrid.jsx";
import * as carrierService from "../../small-parcel-settings.services.jsx";
import * as GridConfig from "../small-parcel-smart-settings-config.jsx";

interface CarrierMarkupNewVersionModelProps {
    sharedSelectedCustomer: any;
    sharedCarrierAccountsGridData: any;
    carrierShipmentServices: any;
    closeCarrierMarkup: () => void;
    selector: string;
    isOpenNewVersionModel: string;
    closeCarrierMarkupNewVersion: () => void;
}

export function CarrierMarkupNewVersionModel(props: CarrierMarkupNewVersionModelProps): JSX.Element {
    const translate = (window as any).translate as any;
    const carrierAccountSchema = GlobalService.GetDynamicCarrierAccountSchema();

    const openEditServiceModel = (e) => {
        var grid = $("#" + props.selector + "CarrierMarkUpGrid").data("kendoGrid");
        if (grid) {
            var dataItem = grid.dataItem($(e.target).closest("tr"));
            if (dataItem) {
                setSelectedServices(dataItem);
                const tmpService = dataItem["services"];
                disableServiceOptions(tmpService);
            }
        }
    };
    const openEditCarrierModel = (e) => {
        var grid = $("#" + props.selector + "CarrierMarkUpGrid").data("kendoGrid");
        if (grid) {
            var dataItem = grid.dataItem($(e.target).closest("tr"));
            if (dataItem) {
                let idArr = dataItem["RowNumber"];
                var eventCustFacUpdate = new CustomEvent("CallEditCarrierFromMarkup", {
                    detail: idArr,
                });
                document.dispatchEvent(eventCustFacUpdate);
                setTimeout(() => {
                    props.closeCarrierMarkupNewVersion();
                }, 100);
            }
        }
    };
    const gridColumns = [
        {
            field: "Carrier",
            title: "Carrier",
            width: 100,
            template: function (dataItem: any) {
                return `<img src="${dataItem.CarrierImg}"/>`;
            },
        },
        {
            field: "AccountNumber",
            title: "Account",
            width: 100,
            template: function (dataItem) {
                return (
                    "<div class='nick-name-wrapper'>" +
                    dataItem.NickName +
                    "</div> <div class='account-wrapper'>" +
                    dataItem.AccountNumber +
                    "</div> <div class='owner-wrapper'> Owner: " +
                    dataItem.Owner +
                    "</div>"
                );
            },
        },
        {
            field: "Allocated",
            title: "Markup on service",
            width: 200,
            template: function (dataItem) {
                let returnServiceText = "";
                if (dataItem.IncludeShippingCost === false) {
                    returnServiceText = `<li class="service-list"><label>${translate("Label_All_Services")}</label>`;
                    returnServiceText =
                        returnServiceText +
                        `<span class="no-shipping-cost-wrapper"> When "Include shipping costs" is disabled,<br/> markups don't apply. <span class="edit-carrier-acc">Edit Carrier Account</span></span></li>`;
                    return returnServiceText;
                }
                if (dataItem.services.length) {
                    let maxLength = 5;
                    if (dataItem.services.length < 5) {
                        maxLength = dataItem.services.length;
                    }
                    for (let i = 0; i < maxLength; i++) {
                        // eslint-disable-next-line security/detect-object-injection
                        const element = dataItem.services[i];
                        const PercentMarkup = element.PercentMarkup ? element.PercentMarkup + "%" : "";
                        const FlatRateMarkup = element.FlatRateMarkup
                            ? PercentMarkup
                                ? ", $" + element.FlatRateMarkup
                                : "$" + element.FlatRateMarkup
                            : "";
                        returnServiceText =
                            returnServiceText +
                            `<li class="service-list"><label>${
                                element.ShipmentService == null
                                    ? translate("Label_All_Services")
                                    : element.ShipmentService
                            }</label><span>${
                                !element.PercentMarkup && !element.FlatRateMarkup
                                    ? "<div class='no-markup'>" + translate("Label_No_Markup") + "</div>"
                                    : PercentMarkup + FlatRateMarkup
                            }</span></li>`;
                    }
                    if (dataItem.services.length > 5) {
                        returnServiceText =
                            returnServiceText +
                            `<div class="see-more-wrapper"> see ${dataItem.services.length - 5} more services</div>`;
                    }
                }
                return returnServiceText;
            },
        },
        {
            field: "cmdRemove",
            menu: false,
            command: [
                {
                    name: "Edit",
                    text: "",
                    className: "service-edit",
                    iconClass: "fa fa-pencil",
                    visible: function (dataItem) {
                        return dataItem.IncludeShippingCost === true;
                    },
                    click: openEditServiceModel,
                },
                {
                    name: "Disabled Edit",
                    text: "",
                    className: "service-edit-disabled k-disabled",
                    iconClass: "fa fa-pencil k-disabled",
                    visible: function (dataItem) {
                        return dataItem.IncludeShippingCost === false;
                    },
                    click: function () {
                        return "";
                    },
                },
            ],
            title: "&nbsp;",
            width: 20,
        },
    ];
    const gridSchema = GridConfig.getCarrierMarkUpSettingsSchema();
    const [carrierOptions, setCarrierOptions] = useState([]);
    const [carrier, setCarrier] = useState("");
    const [allCarrierData, setAllCarrierData] = useState([]);
    const [carrierData, setCarrierData] = useState([]);
    const [selectedServices, setSelectedServices] = useState(null);
    const [deleteUris, setDeleteUris] = useState([]);
    const [isSaveDisabled, setIsSaveDisabled] = useState(false);
    const [saveLoader, setSaveLoader] = useState(false);

    useEffect(() => {
        // Bind edit service on see more link inside grig row
        $(".see-more-wrapper").off("click");
        $(document).on("click", ".see-more-wrapper", openEditServiceModel);
        $(".edit-carrier-acc").off("click");
        $(document).on("click", ".edit-carrier-acc", openEditCarrierModel);
        initCarrieMarkModel();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const initCarrieMarkModel = () => {
        kendo.ui.progress($("#carrierMarkUpNewVersion"), true);
        carrierService
            .getCarrierMarkup(props.sharedSelectedCustomer.id)
            .then((response) => {
                var tmpCarrierMarkUpResponse = response.data;
                var sharedCarrierAccountsGridData = props.sharedCarrierAccountsGridData;
                var carrierObjWithService = [];
                let tmpIsSaveDisabled = false;
                var carrierOptions = [
                    {
                        text: "All",
                        value: "",
                    },
                ];
                // create carrier object array from carrier grid data
                for (let i = 0; i < sharedCarrierAccountsGridData.length; i++) {
                    const element = sharedCarrierAccountsGridData[`${i}`];

                    //set carrier option for dropdown and prevent duplicate
                    let index = _.findIndex(carrierOptions, function (carrier) {
                        return carrier.value === element.Carrier;
                    });
                    if (index === -1) {
                        carrierOptions.push({
                            text: element.Carrier,
                            value: element.Carrier,
                        });
                    }
                    // Prepare data to set for grid
                    carrierObjWithService.push({
                        Carrier: element.Carrier,
                        CarrierImg: getCarrierImage(element.Carrier),
                        NickName: element.NickName,
                        AccountNumber: element.AccountNumber,
                        CustomerCarrierAccountId: element.CustomerCarrierAccountId,
                        FacilityCarrierAccountId: element.FacilityCarrierAccountId,
                        Owner: element.Owner,
                        IncludeShippingCost: element.IncludeShippingCost,
                        RowNumber: element.RowNumber,
                        services: [],
                    });
                }
                // Add service in to particular carrier
                for (let i = 0; i < tmpCarrierMarkUpResponse.length; i++) {
                    // eslint-disable-next-line security/detect-object-injection
                    const element = tmpCarrierMarkUpResponse[i];
                    var carrierInLowerCase = element.Carrier.toLowerCase();
                    // eslint-disable-next-line no-loop-func
                    let index = _.findIndex(carrierObjWithService, function (carrierObj) {
                        return (
                            carrierObj.Carrier.toLowerCase() === carrierInLowerCase &&
                            element.FacilityCarrierAccountId === carrierObj.FacilityCarrierAccountId &&
                            element.CustomerCarrierAccountId === carrierObj.CustomerCarrierAccountId
                        );
                    });
                    if (index !== -1) {
                        // eslint-disable-next-line security/detect-object-injection
                        carrierObjWithService[index].services.push(element);
                    }
                }
                // check  null shipmentService is available if not then create and at last make first index
                // eslint-disable-next-line array-callback-return
                Object.keys(carrierObjWithService).map((key, index) => {
                    var isNullServiceAvailable = false;

                    // eslint-disable-next-line security/detect-object-injection
                    for (let i = 0; i < carrierObjWithService[index].services.length; i++) {
                        // eslint-disable-next-line security/detect-object-injection
                        const element = carrierObjWithService[index].services[i];
                        if (element.ShipmentService == null) {
                            isNullServiceAvailable = true;
                        }
                        if (!element.ShipmentService || !(element.PercentMarkup || element.FlatRateMarkup)) {
                            tmpIsSaveDisabled = true;
                        }
                    }

                    if (isNullServiceAvailable === false) {
                        carrierObjWithService[`${index}`].services.push({
                            Carrier: carrierObjWithService[`${index}`].Carrier,
                            CarrierMarkupUri: null,
                            CustomerId: props.sharedSelectedCustomer.id,
                            CustomerCarrierAccountId: carrierObjWithService[`${index}`].CustomerCarrierAccountId,
                            FacilityCarrierAccountId: carrierObjWithService[`${index}`].FacilityCarrierAccountId,
                            CustomerName: props.sharedSelectedCustomer.name,
                            CustomerUri: props.sharedSelectedCustomer.uri,
                            FlatRateMarkup: 0,
                            PercentMarkup: 0,
                            ShipmentService: null,
                        });
                    }
                    carrierObjWithService[`${index}`].services.sort(function (x, y) {
                        return x.ShipmentService == null ? -1 : y.ShipmentService == null ? 1 : 0;
                    });
                });
                setAllCarrierData(carrierObjWithService);
                setCarrierData(carrierObjWithService);
                setCarrierOptions(carrierOptions);
                setDeleteUris([]);
                setSelectedServices(null);
                setIsSaveDisabled(tmpIsSaveDisabled);
            })
            .finally(() => {
                kendo.ui.progress($("#carrierMarkUpNewVersion"), false);
            });
    };
    const cancelEditServiceModel = () => {
        setSelectedServices(null);
    };
    const saveServices = () => {
        setSaveLoader(true);
        var carrierMarkups = [];
        var tmpDeleteUris = deleteUris;
        var nullShipmentServiceCounter = 0;
        for (let i = 0; i < selectedServices.services.length; i++) {
            const element = selectedServices.services[`${i}`];
            if (!element.ShipmentService) {
                nullShipmentServiceCounter = nullShipmentServiceCounter + 1;
            }
            if (
                nullShipmentServiceCounter === 1 &&
                (parseFloat(element.FlatRateMarkup) || parseFloat(element.PercentMarkup))
            ) {
                carrierMarkups.push(element);
            }
            if (element.CarrierMarkupUri && !parseFloat(element.FlatRateMarkup) && !parseFloat(element.PercentMarkup)) {
                tmpDeleteUris.push(element.CarrierMarkupUri);
            }
        }
        // set object of markUp list in group by carrier
        var payloads = {
            DeleteUris: tmpDeleteUris,
            CarrierMarkups: carrierMarkups,
        };
        carrierService
            .saveCarrierMarkup(payloads)
            .then((response) => {
                GlobalService.notification("success", translate("Label_Carrier_Markup_Success"));
                initCarrieMarkModel();
            })
            .finally(() => {
                setSaveLoader(false);
            });
    };
    const normalizeCarrierName = (name) =>
        String(name || "")
            .replace(/[^a-zA-Z0-9]/g, "")
            .toLowerCase();

    const getCarrierIdentity = (selectedCarrier) => {
        const selectedCarrierNormalized = normalizeCarrierName(selectedCarrier);
        const names = new Set([String(selectedCarrier || "")]);
        let logo = "";

        if (["tusk", "tusklogistics"].includes(selectedCarrierNormalized)) {
            names.add("Tusk");
            names.add("Tusk Logistics");
        }

        if (carrierAccountSchema && Object.keys(carrierAccountSchema).length !== 0) {
            for (const providerName in carrierAccountSchema) {
                const tmpCarriers = carrierAccountSchema[`${providerName}`]?.carriers || {};
                for (const carrier in tmpCarriers) {
                    const carrierDefinition = tmpCarriers[`${carrier}`];
                    const candidateNames = Array.from(names).map(normalizeCarrierName);
                    const identityNames = [
                        carrier,
                        carrierDefinition?.carrierName,
                        ...(carrierDefinition?.carrierNameAliases || []),
                    ].filter(Boolean);

                    if (identityNames.some((name) => candidateNames.includes(normalizeCarrierName(name)))) {
                        identityNames.forEach((name) => names.add(String(name)));
                        logo = carrierDefinition?.logo || logo;
                    }
                }
            }
        }

        return { names: Array.from(names), logo };
    };

    const getCarrierImage = (selectedCarrier) => {
        const carrierIdentity = getCarrierIdentity(selectedCarrier);
        return carrierIdentity.logo || "assets/images/3PL_Logo_Orange.png";
    };

    const getCarrierServiceOptions = (selectedCarrier) => {
        if (!selectedCarrier) {
            return [];
        }

        const normalizedNames = getCarrierIdentity(selectedCarrier).names.map(normalizeCarrierName);
        const matchingServiceEntry = Object.entries(props.carrierShipmentServices || {}).find(([key]) =>
            normalizedNames.includes(normalizeCarrierName(key))
        );
        return matchingServiceEntry ? matchingServiceEntry[1] : [];
    };
    const onCarrierChange = (e) => {
        let tmpData = allCarrierData;
        if (e.target.value) {
            tmpData = _.filter(allCarrierData, function (currentObj) {
                return currentObj.Carrier === e.target.value;
            });
        }
        setCarrier(e.target.value);
        setCarrierData(tmpData);
    };
    const handleChangeEvent = (e, index) => {
        let serviceOption = selectedServices.services;
        if (e.target.name === "PercentMarkup" || e.target.name === "FlatRateMarkup") {
            serviceOption[`${index}`][e.target.name] = e.target.value ? e.target.value : 0;
        } else {
            serviceOption[`${index}`][e.target.name] = e.target.value;
        }
        disableServiceOptions(serviceOption);
        setSelectedServices({ ...selectedServices, services: serviceOption });
        setIsSaveDisabled(validateSaveButton(serviceOption));
    };
    const manageCarrierMarkUp = (key, param_index, service) => (e) => {
        let serviceOption = selectedServices.services;
        let tmpDeleteUris = deleteUris;

        if (typeof param_index != "undefined") {
            var removeCarrierUri = serviceOption[`${param_index}`].CarrierMarkupUri;
            if (removeCarrierUri) {
                tmpDeleteUris.push(removeCarrierUri);
            }
            serviceOption.splice(param_index, 1);
        } else {
            serviceOption.push({
                Carrier: key,
                CarrierMarkupUri: null,
                CustomerCarrierAccountId: service.CustomerCarrierAccountId,
                FacilityCarrierAccountId: service.FacilityCarrierAccountId,
                CustomerId: props.sharedSelectedCustomer.id,
                CustomerName: props.sharedSelectedCustomer.name,
                CustomerUri: props.sharedSelectedCustomer.uri,
                FlatRateMarkup: 0,
                PercentMarkup: 0,
                ShipmentService: null,
            });
        }
        setIsSaveDisabled(validateSaveButton(serviceOption));
        setSelectedServices({ ...selectedServices, services: serviceOption });
        setDeleteUris(tmpDeleteUris);
        disableServiceOptions(serviceOption);
    };
    const disableServiceOptions = (carrierMarkUp) => {
        setTimeout(() => {
            carrierMarkUp.forEach((service, index) => {
                if (index === 0) {
                    $("#" + service.Carrier.toLowerCase().replace(/\s+/g, "") + "_ShipmentService option").removeAttr(
                        "disabled"
                    );
                }
                $(
                    "#" +
                        service.Carrier.toLowerCase().replace(/\s+/g, "") +
                        "_ShipmentService option[value='" +
                        service.ShipmentService +
                        "']"
                ).attr("disabled", "disabled");
            });
        }, 100);
    };
    const validateSaveButton = (carrierMarkUp) => {
        var isSaveDisabled = false;
        for (let i = 1; i < carrierMarkUp.length; i++) {
            const element = carrierMarkUp[`${i}`];
            if (!element.ShipmentService || !(element.PercentMarkup || element.FlatRateMarkup)) {
                isSaveDisabled = true;
                break;
            }
        }
        return isSaveDisabled;
    };
    const serviceOptions = selectedServices ? getCarrierServiceOptions(selectedServices.Carrier) : "";
    return (
        <WmsModel
            id={"carrierMarkUpNewVersion"}
            title={translate("Label_Carrier_Markup")}
            width={999}
            height={872}
            class="carrier-markup-new-version-model-wrapper"
            onCloseFunc={props.closeCarrierMarkupNewVersion}
            isOpen={props.isOpenNewVersionModel}
            customClass="wms-model-new-ui-wrapper"
        >
            <div className="model-content-wrapper">
                <div className="fields-wrapper">
                    <div className="carrier-opt-wrapper">
                        {selectedServices == null ? (
                            <WmsDropdown
                                id={"carrier"}
                                name="carrier"
                                label={translate("Label_Carrier")}
                                wmsSelector={props.selector + "carrierServices"}
                                extraWrapperClass={"carrier-wrapper"}
                                onChangeFunc={onCarrierChange}
                                value={carrier}
                                options={carrierOptions}
                                valueField="value"
                                textField="text"
                            />
                        ) : (
                            <div className="carrier-header-wrapper">
                                <div className="img-wrapper">
                                    <img src={getCarrierImage(selectedServices.Carrier)} alt="dynamic-carrier" />
                                </div>
                                <div className="account-info-wrapper">
                                    <div className="name-number-wrapper">
                                        {selectedServices.NickName} • {selectedServices.AccountNumber}
                                    </div>
                                    <div className="owner-wrapper">Account owner: {selectedServices.Owner}</div>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="carrier-grid-wrapper">
                        {selectedServices == null ? (
                            <WmsFormGrid
                                id={props.selector + "CarrierMarkUpGrid"}
                                wmsSelector={props.selector + "CarrierMarkUpGrid"}
                                gridKeySelection={""}
                                columns={gridColumns}
                                staticGridData={carrierData}
                                schema={gridSchema}
                                isColumnsResizable={true}
                                isColumnsReorderable={true}
                                isColumnMenuenable={false}
                                isColumnsSortable={true}
                                parentClassName={"showHeader"}
                                showResetMenu={false}
                                onSelection={() => {}}
                                IsMultipleSelectable={true}
                            />
                        ) : (
                            <div className="service-list-wrapper">
                                <div className="item-value-title-wrapper">
                                    <div className="item-title">Service</div>
                                    <div className="item-title">Markup (%)</div>
                                    <div className="item-title">Markup (flat)</div>
                                </div>
                                {selectedServices.services.map((service, index) => {
                                    return (
                                        <div className="item-value-wrapper" key={index}>
                                            <div
                                                className="item-value"
                                                key={service.Carrier.replace(/\s+/g, "") + "_serviceList"}
                                            >
                                                <WmsDropdown
                                                    id={
                                                        service.Carrier.toLowerCase().replace(/\s+/g, "") +
                                                        "_ShipmentService"
                                                    }
                                                    name="ShipmentService"
                                                    label=""
                                                    wmsSelector="carrierServices"
                                                    onChangeFunc={(e) => handleChangeEvent(e, index)}
                                                    value={service.ShipmentService}
                                                    options={serviceOptions}
                                                    valueField="Description"
                                                    textField="Description"
                                                    extraWrapperClass={
                                                        (index === 0 ? "disable-shipment-service " : "") +
                                                        "carrier-services"
                                                    }
                                                    disabled={index === 0 ? true : false}
                                                    blankFirstOptionText={
                                                        index === 0 ? translate("Label_All_Services") : ""
                                                    }
                                                    blankFirstOption={true}
                                                />
                                            </div>
                                            <div className="item-value">
                                                <WmsInput
                                                    id="PercentMarkup"
                                                    inputName="PercentMarkup"
                                                    wmsSelector={props.selector + "PercentMarkup"}
                                                    onChangeFunc={(e) => handleChangeEvent(e, index)}
                                                    value={service.PercentMarkup}
                                                    label={""}
                                                    extraSignBeforeValue={"%"}
                                                    extraWrapperClass="default-rate-percentage"
                                                    // eslint-disable-next-line security/detect-unsafe-regex
                                                    regularExp={/^[+-]?([0-9]+([.]?)(\d?\d)?)$/}
                                                />
                                            </div>
                                            <div className="item-value">
                                                <WmsInput
                                                    id="FlatRateMarkupindex"
                                                    inputName="FlatRateMarkup"
                                                    wmsSelector={props.selector + "FlatRateMarkup"}
                                                    onChangeFunc={(e) => handleChangeEvent(e, index)}
                                                    value={service.FlatRateMarkup}
                                                    extraWrapperClass="default-rate-amount"
                                                    label={""}
                                                    extraSignBeforeValue={"$"}
                                                    // eslint-disable-next-line security/detect-unsafe-regex
                                                    regularExp={/^[+-]?([0-9]+([.]?)(\d?\d)?)$/}
                                                />
                                            </div>
                                            <div>
                                                {index === 0 && (
                                                    <WmsButton
                                                        label={""}
                                                        wmsSelector={props.selector + "addServices"}
                                                        onClickFunc={manageCarrierMarkUp(
                                                            service.Carrier,
                                                            undefined,
                                                            service
                                                        )}
                                                        icon="fa-plus"
                                                        parentClassName="manage-carrier-markup-btn"
                                                    />
                                                )}

                                                {index !== 0 && (
                                                    <WmsButton
                                                        label={""}
                                                        buttonType="red"
                                                        wmsSelector={props.selector + "removeServices"}
                                                        onClickFunc={manageCarrierMarkUp(service.Carrier, index, null)}
                                                        disabled={selectedServices.services.length === 1}
                                                        icon="fa-minus"
                                                        parentClassName="manage-carrier-markup-btn"
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div className="footer-btn-holder">
                {selectedServices == null ? (
                    <WmsButton
                        label={translate("Label_Close")}
                        wmsSelector={props.selector + "cancel"}
                        onClickFunc={props.closeCarrierMarkupNewVersion}
                        buttonType="orange"
                        icon={"fa-times-circle-o"}
                    />
                ) : (
                    <>
                        <WmsButton
                            label={translate("Label_Cancel")}
                            wmsSelector={props.selector + "cancelCarrierMarkup"}
                            onClickFunc={cancelEditServiceModel}
                            buttonType="orange"
                            icon={"fa-times-circle-o"}
                        />
                        <WmsButton
                            label={translate("Label_Save")}
                            wmsSelector={props.selector + "SaveCarrierMarkup"}
                            loading={saveLoader}
                            disabled={isSaveDisabled}
                            tooltipText={translate("Label_Markup_Save_Disable_Text")}
                            onClickFunc={saveServices}
                            icon="fa-floppy-o"
                        />
                    </>
                )}
            </div>
        </WmsModel>
    );
}
